import React from 'react';
import { useAuth } from '../AuthContext';
import { BASE_URI } from '../Config';

interface DownloadButtonProps {
    url_str: string
    filename: string
    text: string
}

const DownloadButton: React.FC<DownloadButtonProps> = ({ filename, url_str, text }) => {
    const { userToken } = useAuth();

    const handleDownload = async () => {
        try {
            const response = await fetch(`${BASE_URI}/${url_str}`, {
                headers: {
                    'Authorization': `Bearer ${userToken}`
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = filename;  // You can try to extract filename from Content-Disposition header or set a static name
            document.body.appendChild(a); // For Firefox
            a.click();
            a.remove();  // Remove the anchor after the download is triggered

            setTimeout(() => window.URL.revokeObjectURL(url), 100);  // Clean up the object URL after the download
        } catch (error) {
            console.error('There was an error downloading the file:', error);
        }
    };

    return <a className="authDownload" onClick={handleDownload}>{text}</a>;
};

export default DownloadButton;